import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { TemplateUploadState } from './store/template-upload.state';
import { TemplateUploadService } from './services/template-upload.service';
import { environment } from 'src/environments/environment';
import { AppInitService } from './services/app-init.service';
import { ThemeSwitchService } from './services/theme/theme-switch.service';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    NgxsModule.forRoot(
      [TemplateUploadState], {developmentMode: !environment.production}
    )
  ],
  providers: [
    TemplateUploadService,
    AppInitService,
    ThemeSwitchService
  ]
})
export class CoreModule { }
